<ion-router-outlet *ngIf="loaded"></ion-router-outlet>